import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
const fb = require("../firebaseConfig");

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    activeIR: null,
    irs: null,
    ir: null,
    irSaved: true,
    irTypes: null,
    personnel: null
  },
  mutations: {
    updateField,
    //load summary list of irs
    loadIRS(state, irs) {
      state.irs = irs;
    },
    // load active ir with all details
    loadIR(state, ir) {
      state.ir = ir;
    },
    irSaved(state, status) {
      state.irSaved = status;
    },
    loadIRTypes(state, types) {
      state.irTypes = types;
    },
    activeIR(state, irNum) {
      state.activeIR = irNum;
    },
    sortIRS(state, sorted) {
      state.irs = sorted;
    },
    loadPersonnel(state, personnel) {
      state.personnel = personnel;
    },
    irTypes(state, irTypes) {
      state.irTypes = irTypes;
    }
  },
  actions: {
    loadIRS(context) {
      return new Promise((resolve, reject) => {
        fb.db
          .collection("inspection_reqs")
          .get()
          .then(result => {
            var irs = [];
            result.forEach(function(doc) {
              irs.push({ id: doc.id, data: doc.data() });
            });
            context.commit("loadIRS", irs);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    loadIR(context, irID) {
      return new Promise((resolve, reject) => {
        fb.db
          .collection("inspection_reqs")
          .doc(irID)
          .get()
          .then(result => {
            console.log(result);
            context.commit("loadIR", result.data());
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    saveIR(context) {
      return new Promise((resolve, reject) => {
        context.commit("irSaved", true);
        resolve();
      });
    },
    loadPersonnel(context) {
      return new Promise((resolve, reject) => {
        fb.db
          .collection("users")
          .where("current_projects", "array-contains", "5qIUCTAXftIEdsYIe5pw")
          .get()
          .then(result => {
            var personnel = [];
            result.forEach(function(doc) {
              personnel.push({ id: doc.id, data: doc.data() });
            });
            context.commit("loadPersonnel", personnel);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    loadIRTypes(context) {
      return new Promise((resolve, reject) => {
        fb.db
          .collection("inspection_types")
          .get()
          .then(result => {
            var irTypes = [];
            result.forEach(function(doc) {
              irTypes.push({ id: doc.id, data: doc.data() });
            });
            context.commit("loadIRTypes", irTypes);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    }
    // loadIRTypes(context) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .get("https://ir-json-dummy.netlify.com/types.json")
    //       .then(function(res) {
    //         context.commit("loadIRTypes", res.data.irTypes);
    //         resolve();
    //       })
    //       .catch(function(err) {
    //         reject(err);
    //       });
    //   });
    // }
  },
  getters: {
    getField,
    irs: state => state.irs,
    ir: state => state.ir,
    irSaved: state => state.irSaved,
    activeIR: state => state.activeIR,
    personnel: state => state.personnel,
    irTypes: state => state.irTypes,
    irFor: state => state.irFor
  }
});
